import React, {useState} from 'react';
import {Box, Button, Flex, Input, List, ListItem, Text, useToast, VStack} from '@chakra-ui/react';
import {getData} from "../../services/api";
import {FaCheck} from "react-icons/fa";
import RatingStars from "./RatingStars";

const PlaceSearch = ({onPlaceSelected}) => {
    const [query, setQuery] = useState('');
    const [places, setPlaces] = useState([]);
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [loading, setLoading] = useState(false);

    const toast = useToast()

    const fetchPlaces = async () => {
        if (!query) return;
        setLoading(true);
        setSelectedPlace(null);
        onPlaceSelected(null)

        try {
            const response = await getData('/api/places?query=' + encodeURIComponent(query));
            setPlaces(response.places || []);
            setLoading(false);
            return true;
        } catch (error) {
            toast({
                title: 'Es ist ein Fehler aufgetreten: ' + error.message,
                status: 'error',
                isClosable: true,
            })
            setLoading(false);
            return false;
        }
    };

    const handleSelect = (place) => {
        setSelectedPlace(place);
        onPlaceSelected(place);
    };

    return (
        <VStack spacing={4} align="stretch">
            <Flex gap={5}>
                <Input
                    placeholder="Adresse oder Ort eingeben..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />
                <Button ml='auto' colorScheme="blue" onClick={fetchPlaces} isLoading={loading}>
                    Suchen
                </Button>
            </Flex>

            {places.length > 0 && (
                <Box borderWidth="1px" borderRadius="md" p={4}>
                    <Text fontWeight="bold" mb={2}>Suchergebnisse:</Text>
                    <List spacing={3}>
                        {places.map((place) => (
                            <ListItem key={place.place_id} pb={2}>
                                <Flex>
                                    <Box>
                                        <Text fontSize="md" fontWeight="semibold">{place.name}</Text>
                                        <Text fontSize="sm" color="gray.600">{place.formatted_address}</Text>

                                        <Flex align="center" mt={1}>
                                            <RatingStars rating={place.rating}/>
                                            <Text fontSize="sm" color="gray.500" ml={2}>
                                                ({place.user_ratings_total > 0 ? place.user_ratings_total : 'keine'} Bewertungen)
                                            </Text>
                                        </Flex>
                                    </Box>
                                    <Button
                                        ml='auto'
                                        colorScheme="blue"
                                        variant={"outline"}
                                        onClick={() => handleSelect(place)}
                                        rightIcon={selectedPlace?.place_id === place.place_id ? <FaCheck/> : ''}
                                    >
                                        {selectedPlace?.place_id === place.place_id ? "Ausgewählt" : "Auswählen"}
                                    </Button>
                                </Flex>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            )}
        </VStack>
    );
};

export default PlaceSearch;
